import React from 'react';
import './Link.css';
/**
 * Renders the Link component.
 *
 * @param {React.ReactNode} children - the link's text.
 * @param {string} [className] - the CSS classes.
 * @param {() => void} [onClick] - onClick handler.
 * @param {string} to - the href attribute of the link.
 * @param {string} [style] - the CSS default style 'primary' | 'secondary' | 'custom'
 *
 * @example
 * <Link
 *  to={"https://xyz.com"}
 *  className='a6y-react-auth-form-link
 *  style='custom'
 * >
 *  My Link
 * </Link
 */
var Link = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, _c = _a.onClick, onClick = _c === void 0 ? undefined : _c, _d = _a.style, style = _d === void 0 ? 'primary' : _d, to = _a.to;
    var classNames = require('classnames');
    var LinkClass = classNames((_b = {},
        _b["a6y-react-auth__form__link a6y-react-auth__form__link--" + style] = style
            ? true
            : false,
        _b));
    function handleLinkClick(e) {
        e.preventDefault();
        e.stopPropagation();
        if (onClick)
            onClick(to);
    }
    if (onClick) {
        return (React.createElement("button", { onClick: function (e) { return handleLinkClick(e); }, className: className && className.length > 0 ? className : LinkClass }, children));
    }
    return (React.createElement("a", { href: to, className: className && className.length > 0 ? className : LinkClass }, children));
};
export default Link;
//# sourceMappingURL=Link.js.map